import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  RadioIconContainer,
  RadioIconIcon,
  RadioIconOption,
  RadioIconRadio,
  RadioIconSilencedText,
} from './RadioIconField.styled';
import EmojiIcon from '@components/atoms/Icon/EmojiIcon';

const RadioIconField = ({
  contextValue,
  options,
  handleFormData,
  handleEvent,
  id,
  bgColorDefault = 'white',
  bgColorSelect = '#E2F8F5',
  textColorDefault = 'black',
  textColorSelect = 'black',
}) => {
  const [state, setState] = useState(contextValue || null);
  const [handleCallback, setHandleCallback] = useState(false);

  //execute handleEvent only when we are sure that formData has been handled
  //and new value different from previous and new value exist
  useEffect(() => {
    if (typeof handleEvent === 'function' && handleCallback && state !== null) {
      handleEvent(id, contextValue);
      setHandleCallback(false);
    }
  }, [handleCallback]);

  const handleFieldChange = (key, value) => {
    handleFormData({ name: key, value });
    setState(value);
    //call HandleEvent only after data has been handle dans context value changed
    setHandleCallback(true);
  };

  return (
    <RadioIconContainer>
      {options.map((option) => (
        <RadioIconOption
          key={option.id}
          style={
            option.id === state
              ? {backgroundColor: bgColorSelect, color: textColorSelect}
              : {backgroundColor: bgColorDefault, color: textColorDefault}
          }
          $checked={option.id === state}
        >
          <RadioIconIcon>
            <EmojiIcon name={option.icon} />
          </RadioIconIcon>
          <RadioIconRadio
            type='radio'
            name={id}
            id={option.id}
            value={option.name}
            checked={option.id === state}
            onClick={(event) => handleFieldChange(event.target.name, event.target.id)}
            onChange={(e) => e.preventDefault()}
          />
          {option.name}{' '}
          {option.silencedText && (
            <RadioIconSilencedText $checked={option.id === state}>
              {option.silencedText}
            </RadioIconSilencedText>
          )}
        </RadioIconOption>
      ))}
    </RadioIconContainer>
  );
};

RadioIconField.propTypes = {
  handleFormData: PropTypes.func.isRequired,
  handleEvent: PropTypes.func,
  contextValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.array.isRequired,
  bgColorDefault: PropTypes.string,
  bgColorSelect: PropTypes.string,
  textColorDefault: PropTypes.string,
  textColorSelect: PropTypes.string,
};

export default RadioIconField;
